import * as React from "react";

import Dashboard from "../Dashboard";

const DashboardPanel: React.FC = () => {
	return <Dashboard />;
};

export default DashboardPanel;
